import { render, staticRenderFns } from "./SubMerchant.vue?vue&type=template&id=4d0e475e&"
import script from "./SubMerchant.vue?vue&type=script&lang=js&"
export * from "./SubMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports